module.exports = __webpack_public_path__ + "img/immortalcamp_tech_Normal_ua.096ffb68.webp";